import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/liuyuqinP/workspace/react-datepicker/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "react-datepicker"
    }}>{`react-datepicker`}</h1>
    <p>{`Datepicker 基础组件库，react hook + typescript 代码风格，包含 DatePicker，TimePicker，DateRangePicker 三个子组件:`}</p>
    <ul>
      <li parentName="ul">{`DatePicker，标准单日期选择组件，支持日，周，月，季，年，日期时间共 6 种日期类型选择；`}</li>
      <li parentName="ul">{`TimePicker，标准时间选择组件，全新设计，避免滚动选择，特定时间点直观显示`}</li>
      <li parentName="ul">{`DateRangePicker，范围双日期选择组件，支持日，周，月，季，年 5 种日期维度选择；`}</li>
    </ul>
    <blockquote>
      <i>组件使用的第三方库：lodash，dayjs，classnames，react-popper，rc-slider</i>
    </blockquote>
    <h2 {...{
      "id": "安装"
    }}>{`安装`}</h2>
    <pre><code parentName="pre" {...{}}>{`npm i react-datepicker-ts

`}</code></pre>
    <h2 {...{
      "id": "使用"
    }}>{`使用`}</h2>
    <pre><code parentName="pre" {...{}}>{`import { DatePicker } from 'react-datepicker-ts';

<DatePicker />

// or
import { TimePicker } from 'react-datepicker-ts';

<TimePicker />

// or

import { DateRangePicker } from 'react-datepicker-ts';

<DateRangePicker />

`}</code></pre>
    <h2 {...{
      "id": "主题色变更"
    }}>{`主题色变更`}</h2>
    <p>{`组件默认采用的是绿色主题色系，如需变更，只需要在项目 css 中重写两个主题色相关变量即可，如下图改为 antd 主题色`}</p>
    <pre><code parentName="pre" {...{}}>{`// index.css
:root {
  --c-datepicker-primary: #1890FF;
  --c-datepicker-primary-light: #bae7ff;
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      